import { IFeatureLocationTermsQuery, useFeatureLocationTermsQuery } from 'generated/sanity-graphql';
import { useFeaturesContext } from 'state/features';

interface IUseFeatureGeolocationTermsModalValue {
  featureGeolocationTermsData: IFeatureLocationTermsQuery['FeatureGeolocationTermsModal'] | null;
  featureGeolocationTermsLoading: boolean;
}

export const useFeatureGeolocationTermsModal = (): IUseFeatureGeolocationTermsModalValue => {
  const { featureGeolocationTermsModalsId = '', featureIdsLoading } = useFeaturesContext();

  const { data, loading } = useFeatureLocationTermsQuery({
    skip: !featureGeolocationTermsModalsId,
    variables: { featureLocationTermsId: featureGeolocationTermsModalsId },
  });

  const featureGeolocationTermsLoading = featureIdsLoading || loading;

  return {
    featureGeolocationTermsData: data?.FeatureGeolocationTermsModal ?? null,
    featureGeolocationTermsLoading,
  };
};
